import { Link } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

export function TrialExpiredBanner() {
  const isReadOnly = useAuthStore(s => s.isReadOnly)
  if (!isReadOnly) return null

  return (
    <div className="bg-red-600 text-white px-4 py-2.5 flex items-center justify-center gap-1.5 text-sm flex-wrap">
      <span>Your trial has expired. You're in read-only mode.</span>
      <Link
        to="/subscription"
        className="font-semibold underline underline-offset-2 hover:text-red-100"
      >
        Subscribe
      </Link>
      <span>to make changes.</span>
    </div>
  )
}
